export default __webpack_public_path__ + "static/media/anatomy-background.322dd395.svg";